// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3Q0_W","detailsBorder":"styles_detailsBorder__1x_eo"};